// extracted by mini-css-extract-plugin
export default {"label":"CustomToggleSwitch_label__z8fLV"};